export default {
  message: "Template Client",
  general: {
    login: "Connexion",
    logout: "Se déconnecter"
  },
  options: {
    sortDateAsc: "Date (plus ancienne)",
    sortDateDesc: "Date (plus récente)",
    sortAlphAsc: "A-Z",
    sortAlphDesc: "Z-A"
  },
  navigation: {
    data: "Données",
    maps: "Cartes",
    apps: "Outils",
    reporting: "Rapports",
    analysis: "Analyses",
    back: "retour"
  },
  user: {
    invite: "Mot de passe oublié ?",
    signup: "Créer un compte",
    signInLink: "Déjà inscrit ?",
    account: "Mon compte",
    email: "Email",
    sendEmail: "Validation",
    sendEmailSuccess: "Votre demande de réinitialisation de mot de passe a été prise en compte et un email vous a été envoyé.",
    sendEmailFailure: "Erreur lors votre demande de réinitialisation de mot de passe. Veuillez contacter le support.",
    resetPassword: "Réinitialisation",
    password: "Mot de passe:",
    changePassword: "Changer le mot de passe",
    nextPassword: "Nouveau mot de passe",
    currentPassword: "Mot de passe actuel",
    passwordConfirmation: "Confirmation du nouveau mot de passe",
    differentPasswords: "Veuillez confirmer le nouveau mot de passe",
    wrongPasswordRegex: "8 caractères minimum, avec un chiffre ou un caractère spécial",
    passwordError: "Une erreur s'est produit lors du changement de mot de passe. Veuillez vérifier les valeurs saisies.",
    currentPasswordMismatch: "Le mot de passe actuel saisi n'est pas correct.",
    emptyPasswords: "Le nouveau mot de passe est vide",
    passwordValidation: "Mettre à jour",
    cancel: "Annulation",
    emailValidation: "Enregistrer",
    profileValidation: "Modifier",
    profileExit: "Retour",
    company: "Société",
    department: "Direction",
    position: "Fonction",
    gender: "Civilité",
    direction: "Direction",
    firstname: "Prénom",
    "gms-profile": "Profil Global Map",
    lastname: "Nom",
    share: "Zone d'échange",
    media: "Médiathèque",

    profile: {
      user: 'Profil utilisateur',
      position: 'Fonction',
      save: 'Sauvegarder',
      genders: {
        male: 'Monsieur',
        female: 'Madame',
      }
    },

    support: {
      label: 'Contact',
      message: 'Écrivez ici votre message au support...',
    }
  },

  maps: {
    textFilter: "Rechercher une ou plusieurs cartes",
    emptyResourcesList:"Aucune carte",
    layers: {
      importer: {
        empty: "Aucun élement",
        cancel: "Annuler",
        addLayers: "Ajouter",
      }
    }
  },

  data : {
    textFilter: "Rechercher dans les données",
    emptyResourcesList:"Aucun jeu de données",
    clickOnButton: "Cliquez sur le bouton",
    toDataSetImport: "pour importer un jeu de données"
  },

  filters: {
    searchByName: "Rechercher par nom"
  },
  apps: {
    textFilter: "Rechercher une analyse",
    emptyResourcesList: "Aucun élément",
    templateSettings: "Paramétrage des moteurs",
    templates: {
      textFilter:"Rechercher un modèle",
      emptyResourcesList: "Aucun modèle",
    }
  }
};
